import React from 'react'
import BaseComponent, { errorMap } from './BaseComponent'
import { NavLink } from 'react-router-dom'
import Modal from './Modal'
import _ from 'lodash'
import ReactPaginate from 'react-paginate';
import { parseDate } from './BaseComponent'

export default class ListPage extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { list: [], itemId: null, preloader: true, searchTerm: "", searchBy: _.filter(this.props.data.fields, { type: "text" })[0]?.name, page: 0, pages: 0, category: "test", sortBy: "publicationDate" }
    this._bind('delete', 'getData', 'searchUpdated', 'closeConfirm', 'handlePageClick')

    this.handleSearch = _.debounce( () => {
      this.setState({ list: [], preloader: true })
      this.getData()
    }, 600);
  }

  getCount() {
    let url = this.props.API+this.props.data.endpointList.replace("/list", "") + "/count"
    let params = {
      query: this.state.searchTerm,
      sort: this.state.searchBy,
      order: this.state.order,
      offset: this.state.page*20,
      limit: 20
    }

    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
      })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      if (!result.status.success) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident)}}), true);
      } else {
        this.setState({ pages: Math.ceil(result.data.count/20) })
      }
    }, (error) => {
      console.log(error)
    })
  }

  getData() {
    let url = this.props.API+this.props.data.endpointList
    let params = {
      query: this.state.searchTerm,
      sort: this.state.searchBy,
      order: this.state.order,
      offset: this.state.page*20,
      limit: 20
    }

    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
      })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      if (!result.status.success) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident)}}), true);
      } else {
        //console.log(result)
        let res = result.data || []
        if (res === null) {
          res = []
        }
        const ordered = res
        this.getCount()
        this.setState({ list: ordered, preloader: false, pages: result.data ? result.data.pages : [] })
      }
    }, (error) => {
      console.log(error)
    })
  }

  componentDidMount() {
    this.getData()
  }

  delete(id) {
    this.setState({ preloader: true })
    let url = this.props.API+this.props.data.endpointDelete
    const params = {
      [this.props.data.content]: {
        uuid: id
      }
    }
    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
      },
      body: JSON.stringify(params)
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      //console.log(result)
      this.setState({ confirm: false, itemId: null })
      this.getData()
      if (!result.status.success) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident)}}), true);
      } else {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "green", 'content' : "Pomyślnie usunięto."}}), true);
      }
    }, (error) => {
      console.log(error)
      window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : "Coś poszło nie tak."}}), true);
      this.setState({ preloader: false })
    })
  }

  searchUpdated(term) {
    this.setState({searchTerm: term})
  }

  closeConfirm() {
    this.setState({ confirm: false, itemId: null })
  }

  handlePageClick(data) {
    this.setState({ page: data.selected, preloader: true }, () => {
      this.getData()
    })
  }

  render () {
    let list = null

    let filteredList = this.props.data.table === "group" ? this.state.list : _.filter(this.state.list, (item) => {
      const itm =  _.get(item, this.state.searchBy) ? _.get(item, this.state.searchBy)?.toLowerCase() : _.get(item, this.state.searchBy.split(".")[this.state.searchBy.split(".").length-1])?.toLowerCase()
      if(itm?.includes(this.state.searchTerm.toLowerCase())) return true
    })

    const Confirm = (
      <div className="confirm">
        <h4>Czy jesteś pewny?</h4>
        <div className="btn-holder">
          <button className="btn" onClick={ this.closeConfirm }><span>Nie</span></button>
          <button className="btn" onClick={ this.delete.bind(null, this.state.itemId) }><span>Tak</span></button>
        </div>
      </div>
    )

    if (filteredList?.length > 0) {
      const sortedList = this.props.data.table === "articles" || this.props.data.table === "offers" || this.props.data.table === "events" || this.props.data.table === "faq" ? _.orderBy(filteredList, [this.state.sortBy], ['desc']) : filteredList
      list = sortedList.map((item, i) => {
        return (
          <li key={ i }>
            <div className="date">
              { item.created?.date ? <span><strong>Data utworzenia:</strong> { parseDate(item.created?.date, true, true) }<br/></span> : null }
              { item.updated?.date ? <span><strong>Data edycji:</strong> { parseDate(item.updated?.date, true, true) }<br/></span> : null }
              { item.publicationDate ? <span><strong>Data publikacji:</strong> { parseDate(item.publicationDate, true, true) }</span> : null }
            </div>
            { item.image ? <div className="thumb">
              <img src={ item.image } alt=""/>
            </div> : null }
            { item.ident && <NavLink to={ this.props.data.route + "/" + item.uuid } style={{ textDecoration: "none" }}><h4>Ident: { item.ident }</h4></NavLink> }<br/>
            { item.group?.description && <NavLink to={ this.props.data.route + "/" + item.uuid } style={{ textDecoration: "none" }}><h4>Grupa: { item.group.description }</h4></NavLink> }<br/>
            { item.content?.title || item.title || item.name || item.description && <NavLink to={ this.props.data.route + "/" + item.uuid } style={{ textDecoration: "none" }}><h4 className={ item.image ? "withimg" : "" }>{ this.props.data.table === "faq" ? <span>Kategoria: { item.categoryName }<br/></span> : null }Nazwa: { item.content?.title ? item.content.title : item.title ? item.title : item.name ? item.name : item.description }</h4></NavLink> }
            { item.priority || item.priority === 0  ? <p>Kolejność: { item.priority }</p> : null }
            <div className="controls">
              { (this.props.user.role === "ADMIN" || this.props.user.role === "Moderator") && (this.props.data.route !== "/tracks" || item.in_use === false ) && this.props.data.delete ? <div onClick={ () => { this.setState({ confirm: true, itemId: item.uuid }) } }><img src="/assets/img/icons/delete.png" alt=""/><span>{ this.props.data.delete }</span></div> : null }
              { (this.props.user.role === "ADMIN" || this.props.user.role === "Moderator") && this.props.data.edit ? <div><NavLink to={ this.props.data.route + "/" + item.uuid }><img src="/assets/img/icons/edit.png" alt=""/><span>{ this.props.data.edit }</span></NavLink></div> : this.props.data.edit ? <div><NavLink to={ this.props.data.route + "/" + item.uuid }><img src="/assets/img/icons/edit.png" alt=""/><span>Podgląd</span></NavLink></div> : null }
            </div>
          </li>
        )
      })
    }

    return (
      <section className="list">
        <div className="container">
    			<h1>{ this.props.data.name }</h1>
          { (this.props.user.role === "ADMIN" || this.props.user.role === "Moderator") && this.props.data.new  ? <NavLink to={ this.props.data.new } className="btn"><span>{ this.props.data.add }</span></NavLink> : null }
          <div className="search-box">
            <div className="search-input si-select">
              <label htmlFor="searchBy">Szukaj według:</label>
              <select id="searchBy" name="searchBy" value={ this.state.searchBy } onChange={ (e) => { this.setState({ searchBy: e.target.value }) } }>
                { _.filter(this.props.data.fields, { type: "text" }).map((item, i) => {
                  return (
                    <option key={ i } value={ item.name }>{ item.placeholder }</option>
                  )
                }) }
              </select>
            </div>
            <div className="search-input">
              <input type="text" placeholder="Wyszukaj" value={ this.state.searchTerm } onChange={ (e) => { this.setState({ searchTerm: e.target.value }) } }/>
            </div>
            { this.props.data.table === "articles" || this.props.data.table === "offers" || this.props.data.table === "events" || this.props.data.table === "faq" ? <div className="sort">
              <label htmlFor="searchBy">Sortuj według:</label>
              <select id="sortBy" name="sortBy" value={ this.state.sortBy } onChange={ (e) => { this.setState({ sortBy: e.target.value }) } }>
                <option value="publicationDate">Data publikacji</option>
                <option value="updated">Data edycji</option>
              </select>
            </div> : null }
          </div>
          { this.state.pages > 0 ? <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={this.state.pages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={ this.handlePageClick }
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            forcePage={ this.state.page }
          /> : null }
          <ul className="list-items" style={(this.props.data.content === "activation" || this.props.data.content === "campaign") && this.props.screen.width > 720 ? {marginTop: "100px"} : {}}>
            { filteredList?.length > 0 ? list : <h5>Brak wyników!</h5> }
            { this.state.preloader ? <div className="preloader"><span></span></div> : null }
          </ul>
          { this.state.pages > 0 ? <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={this.state.pages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={ this.handlePageClick }
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            forcePage={ this.state.page }
          /> : null }
	  	  </div>
        <Modal open={ this.state.confirm } hidePopup={ this.closeConfirm }>{ Confirm }</Modal>
      </section>
    )
  }
}
